import axios from 'axios';
import Alert from '@mui/lab/Alert';
import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import Paper from '@mui/material/Paper';
import React, { useState } from 'react';
import Loader from 'react-loader-spinner';
import { useHistory } from 'react-router';
import Button from '@mui/material/Button';
import Snackbar from '@mui/material/Snackbar';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';

import { classes } from '../styles';
import DashboardNavBar from '../../../components/Dashboard/Common/Navbar';
import DashboardSideMenu from '../../../components/Dashboard/Common/SidebarMenu';

const baseUrl = process.env.REACT_APP_BASE_URL;

const DashboardRegisterVolunteerPage = () => {
  const history = useHistory();

  const [loading, setLoading] = useState(false);
  const [specificError, setSpecificError] = useState('');
  const [snackbarState, setSnackbarState] = useState({
    warningOpen: false,
    errorOpen: false,
    successOpen: false,
    specificErrorOpen: false,
    vertical: 'center',
    horizontal: 'center',
  });
  const [volunteer, setVolunteer] = useState({
    firstName: '',
    lastName: '',
    phoneNumber: '',
    email: '',
    country: '',
    city: '',
    motivation: '',
  });

  const { successOpen, errorOpen, specificErrorOpen, vertical, horizontal } =
    snackbarState;

  const handleClose = () => {
    setSnackbarState({
      ...snackbarState,
      errorOpen: false,
      successOpen: false,
      specificErrorOpen: false,
    });
  };

  const breadcrumbs = [
    <Link
      underline="hover"
      key="1"
      color="inherit"
      href="/dashboard"
      onClick={() => history.push('/dashboard')}
    >
      Dashboard
    </Link>,
    <Link
      underline="hover"
      key="2"
      color="inherit"
      href="/dashboard/volunteers/"
      onClick={() => history.push('/dashboard/volunteers')}
    >
      Volunteers
    </Link>,
    <Typography key="3" color="text.primary">
      Register Volunteer
    </Typography>,
  ];

  const handleInputChange = (e) => {
    const key = e.target.name;
    const value = e.target.value;

    setVolunteer({ ...volunteer, [key]: value });
  };

  const handleSubmission = (e) => {
    e.preventDefault();

    setLoading(true);

    const payload = {
      firstName: volunteer.firstName,
      lastName: volunteer.lastName,
      email: volunteer.email,
      country: volunteer.country,
      city: volunteer.city,
      motivation: volunteer.motivation,
      phoneNumber: volunteer.phoneNumber,
    };

    axios
      .post(`${baseUrl}/volunteer`, payload)
      .then(
        ({
          data: {
            data: { _id },
          },
        }) => {
          setSnackbarState({ ...snackbarState, successOpen: true });
          setLoading(false);
          setVolunteer({
            firstName: '',
            lastName: '',
            phoneNumber: '',
            email: '',
            country: '',
            city: '',
            motivation: '',
          });
          setTimeout(() => {
            history.push(`/dashboard/volunteers/${_id}`);
          }, 5000);
        }
      )
      .catch((err) => {
        console.log(err.response.data.message);

        if (err.response.data.message) {
          setSpecificError(err.response.data.message);
          setSnackbarState({ ...snackbarState, specificErrorOpen: true });
        } else {
          setSnackbarState({ ...snackbarState, errorOpen: true });
        }

        setLoading(false);
      });
  };

  return (
    <Box sx={classes.container}>
      <DashboardNavBar />
      <DashboardSideMenu />
      {/* PAGE */}
      <Box sx={classes.pageContainer}>
        <Snackbar
          open={errorOpen}
          autoHideDuration={10000}
          onClose={handleClose}
          anchorOrigin={{ vertical, horizontal }}
        >
          <Alert onClose={handleClose} severity="error" sx={{ width: '100%' }}>
            Could not register the volunteer. Try again.
          </Alert>
        </Snackbar>
        <Snackbar
          open={specificErrorOpen}
          autoHideDuration={10000}
          onClose={handleClose}
          anchorOrigin={{ vertical, horizontal }}
        >
          <Alert onClose={handleClose} severity="error" sx={{ width: '100%' }}>
            {specificError}
          </Alert>
        </Snackbar>
        <Snackbar
          open={successOpen}
          autoHideDuration={10000}
          onClose={handleClose}
          anchorOrigin={{ vertical, horizontal }}
        >
          <Alert
            onClose={handleClose}
            severity="success"
            sx={{ width: '100%' }}
          >
            Volunteer registered successfully!
          </Alert>
        </Snackbar>
        <Breadcrumbs
          separator={<NavigateNextIcon fontSize="small" />}
          aria-label="breadcrumb"
        >
          {breadcrumbs}
        </Breadcrumbs>
        <Box
          sx={classes.paperContainer}
          component="form"
          onSubmit={handleSubmission}
        >
          <Paper elevation={4} variant="outlined" square>
            <TextField
              id="filled-basic"
              label="First Name"
              name="firstName"
              variant="filled"
              value={volunteer.firstName}
              onChange={handleInputChange}
              required
              sx={classes.commonTextFieldWidth}
            />

            <br />
            <br />

            <TextField
              id="filled-basic"
              label="Last Name"
              name="lastName"
              variant="filled"
              value={volunteer.lastName}
              onChange={handleInputChange}
              required
              sx={classes.commonTextFieldWidth}
            />

            <br />
            <br />

            <TextField
              id="filled-basic"
              label="Phone Number"
              name="phoneNumber"
              variant="filled"
              value={volunteer.phoneNumber}
              onChange={handleInputChange}
              required
              sx={classes.commonTextFieldWidth}
            />

            <br />
            <br />

            <TextField
              id="filled-basic"
              label="Email"
              name="email"
              variant="filled"
              value={volunteer.email}
              onChange={handleInputChange}
              required
              sx={classes.commonTextFieldWidth}
              type="email"
            />

            <br />
            <br />

            <TextField
              id="filled-basic"
              label="Country"
              name="country"
              variant="filled"
              value={volunteer.country}
              onChange={handleInputChange}
              required
              sx={classes.commonTextFieldWidth}
            />

            <br />
            <br />

            <TextField
              id="filled-basic"
              label="City"
              name="city"
              variant="filled"
              value={volunteer.city}
              onChange={handleInputChange}
              required
              sx={classes.commonTextFieldWidth}
            />

            <br />
            <br />

            <TextField
              id="standard-multiline-static"
              label="Motivation"
              name="motivation"
              variant="filled"
              multiline
              rows={5}
              value={volunteer.motivation}
              onChange={handleInputChange}
              required
              sx={classes.commonTextFieldWidth}
            />

            <br />
            <br />

            <Box sx={classes.buttonsContainer}>
              {loading ? (
                <Button variant="contained" color="primary" disabled>
                  <Loader type="Oval" color="#1976d2" height={30} width={50} />
                </Button>
              ) : (
                <>
                  <Button
                    variant="contained"
                    color="primary"
                    sx={classes.buttonMargin}
                    type="submit"
                  >
                    Register
                  </Button>
                  <Button
                    variant="outlined"
                    onClick={() => history.push('/dashboard/volunteers')}
                  >
                    Cancel
                  </Button>
                </>
              )}
            </Box>
          </Paper>
        </Box>
      </Box>
    </Box>
  );
};

export default DashboardRegisterVolunteerPage;
